// Reformule un texte REMC (écrit à destination de l'enseignant :
// « Aidez votre élève à... », « Puisez dans... ») en s'adressant
// directement à l'élève à la 2ᵉ personne du singulier (tu).
//
// Utilisé par :
//  - /cours/progression (bouton "Trame détaillée (REMC)" + panneau accordéon REMC par étape)
//  - EtapeRemcCard (utilisé dans /examen-blanc/:token et /fiche/:token pour les élèves)
export function toTu(input) {
  if (!input) return '';
  let s = String(input);

  // Reformulations d'incipit fréquents dans le REMC
  s = s.replace(/^Aidez\s+votre\s+élève\s+à\s+(comprendre|savoir|apprendre|percevoir|identifier|maîtriser|analyser)\b/i, 'Tu vas $1');
  s = s.replace(/Aidez\s+votre\s+élève\s+à\s+/gi, 'Tu vas ');
  s = s.replace(/Amenez\s+votre\s+élève\s+à\s+/gi, 'Tu vas ');
  s = s.replace(/Faites\s+découvrir\s+à\s+votre\s+élève\s+/gi, 'Tu vas découvrir ');
  s = s.replace(/Expliquez\s+à\s+votre\s+élève\s+/gi, 'Nous allons voir ');
  s = s.replace(/Puisez\s+dans\s+les\s+ressources\s+de\s+votre\s+élève\.?\s*/gi, '');
  s = s.replace(/Partez\s+d[’']une\s+situation\s+vécue\s*,?\s*pour\s+faire\s+ressortir\s+/gi, "On part d'une situation vécue pour faire ressortir ");
  s = s.replace(/Démontrez\s+qu['’]?\s*/gi, "Retiens qu'");
  s = s.replace(/Présentez\s+/gi, 'Tu vas voir ');

  // Boilerplate "auto-généré" qu'on retrouve dans les compétences non enrichies
  s = s.replace(/Pour\s+lui\s+apprendre\s+à\s+/gi, "Pour t'apprendre à ");
  s = s.replace(/Pour\s+lui\s+(permettre|montrer|expliquer|faire|donner|éviter)\b/gi, 'Pour te $1');
  // "tu peux proposer à l'élève de X" → "tu peux essayer de X" (formule teacher-to-teacher)
  s = s.replace(/\btu\s+peux\s+proposer\s+à\s+l['’]?élève\s+de\s+/gi, 'tu peux essayer de ');
  s = s.replace(/\bvous\s+pouvez\s+proposer\s+à\s+l['’]?élève\s+de\s+/gi, 'vous pouvez essayer de ');
  s = s.replace(/proposer\s+à\s+l['’]?élève\s+de\s+/gi, 'te proposer de ');
  s = s.replace(/proposer\s+à\s+toi\s+de\s+/gi, 'te proposer de ');
  s = s.replace(/Le\s+but\s+étant\s+qu['’]?il\s+prenne\s+conscience\b/gi, 'Le but étant que tu prennes conscience');
  s = s.replace(/Le\s+but\s+étant\s+qu['’]?il\s+/gi, 'Le but étant que tu ');
  s = s.replace(/Le\s+but\s+étant\s+qu['’]?elle\s+/gi, 'Le but étant que tu ');
  s = s.replace(/Il\s+est\s+important\s+que\s+l['’]?élève\s+puisse\s+/gi, 'Il est important que tu puisses ');
  s = s.replace(/Il\s+est\s+important\s+que\s+l['’]?élève\s+/gi, 'Il est important que tu ');
  s = s.replace(/Ces\s+arguments\s+doivent\s+l['’]amener\s+à\s+/gi, "Ces arguments doivent t'amener à ");
  s = s.replace(/(doivent|doit|peut|peuvent)\s+l['’](amener|aider|inciter|encourager|permettre|conduire|pousser)\s+à\s+/gi,
    (m, verb, verb2) => `${verb} t'${verb2} à `);

  // « à l'élève » / « de l'élève » / « pour l'élève » / « chez l'élève » → « à toi » / etc.
  s = s.replace(/\bà\s+l['’]?élève\b/gi, 'à toi');
  s = s.replace(/\bde\s+l['’]?élève\b/gi, 'de toi');
  s = s.replace(/\bpour\s+l['’]?élève\b/gi, 'pour toi');
  s = s.replace(/\bchez\s+l['’]?élève\b/gi, 'chez toi');
  s = s.replace(/\bavec\s+l['’]?élève\b/gi, 'avec toi');

  // « l'élève + verbe » avec conjugaison automatique
  s = s.replace(/\bl['’]?élève\s+doit\s+/gi, 'tu dois ');
  s = s.replace(/\bl['’]?élève\s+peut\s+/gi, 'tu peux ');
  s = s.replace(/\bl['’]?élève\s+sait\s+/gi, 'tu sais ');
  s = s.replace(/\bl['’]?élève\s+prend\s+/gi, 'tu prends ');
  s = s.replace(/\bl['’]?élève\s+puisse\s+/gi, 'tu puisses ');
  s = s.replace(/\bl['’]?élève\s+prenne\s+/gi, 'tu prennes ');
  s = s.replace(/\bl['’]?élève\s+fait\s+/gi, 'tu fais ');
  s = s.replace(/\bl['’]?élève\s+va\s+/gi, 'tu vas ');
  s = s.replace(/\bl['’]?élève\s+est\s+/gi, 'tu es ');
  s = s.replace(/\bl['’]?élève\s+a\s+/gi, 'tu as ');

  // « qu'il/qu'elle + verbe » (dans un contexte où on parle de l'élève) → « que tu + verbe »
  s = s.replace(/\bqu['’]il\s+prenne\s+conscience\b/gi, 'que tu prennes conscience');
  s = s.replace(/\bqu['’]il\s+puisse\b/gi, 'que tu puisses');
  s = s.replace(/\bqu['’]il\s+comprenne\b/gi, 'que tu comprennes');
  s = s.replace(/\bqu['’]il\s+identifie\b/gi, 'que tu identifies');
  s = s.replace(/\bqu['’]il\s+maîtrise\b/gi, 'que tu maîtrises');
  s = s.replace(/\bqu['’]il\s+apprenne\b/gi, 'que tu apprennes');
  s = s.replace(/\bqu['’]il\s+réagisse\b/gi, 'que tu réagisses');
  s = s.replace(/\bqu['’]il\s+sache\b/gi, 'que tu saches');

  // Puces / listes REMC qui commencent par « De + infinitif » → « Tu vas + infinitif »
  s = s.replace(/^De\s+([a-zàâçéèêëîïôûùüÿœ])/i, (m, c) => 'Tu vas ' + c.toLowerCase());
  s = s.replace(/(\n\s*[-•]\s*)De\s+([a-zàâçéèêëîïôûùüÿœ])/gi, (m, dash, c) => `${dash}tu vas ${c.toLowerCase()}`);
  // « D'activer » / « D'utiliser » → « Tu vas activer / utiliser » (on retire le d')
  s = s.replace(/^D['’]([aeiouhy])/i, (m, v) => `Tu vas ${v.toLowerCase()}`);
  s = s.replace(/(\n\s*[-•]\s*)D['’]([aeiouhy])/gi, (m, dash, v) => `${dash}tu vas ${v.toLowerCase()}`);

  // Verbes pronominaux « s'installer », « s'y installer » → « t'installer », « t'y installer »
  s = s.replace(/\bs['’]y\s+([a-zàâçéèêëîïôûùüÿœ])/gi, (m, c) => `t'y ${c.toLowerCase()}`);
  s = s.replace(/\bs['’](installer|arrêter|engager|assurer|approcher|éloigner|adapter|habituer|préparer|placer|positionner|orienter|informer)\b/gi,
    (m, verb) => `t'${verb.toLowerCase()}`);
  s = s.replace(/^S['’](installer|arrêter|engager|assurer|approcher|éloigner|adapter|habituer|préparer|placer|positionner|orienter|informer)\b/i,
    (m, verb) => `T'${verb.toLowerCase()}`);
  s = s.replace(/(\n\s*[-•]\s*)S['’](installer|arrêter|engager|assurer|approcher|éloigner|adapter|habituer|préparer|placer|positionner|orienter|informer)\b/gi,
    (m, dash, verb) => `${dash}t'${verb.toLowerCase()}`);

  // Références à « votre élève » / « l'élève » → « tu » / « toi »
  s = s.replace(/\bvotre\s+élève\b/gi, 'toi');
  s = s.replace(/\bl['’]?élève\b/gi, 'tu');
  s = s.replace(/\bles\s+élèves\b/gi, 'vous');

  // Impératifs pluriels courants → tutoiement
  s = s.replace(/\bIdentifiez\b/g, 'Identifie');
  s = s.replace(/\bVérifiez\b/g, 'Vérifie');
  s = s.replace(/\bAdaptez\b/g, 'Adapte');
  s = s.replace(/\bAnticipez\b/g, 'Anticipe');
  s = s.replace(/\bObservez\b/g, 'Observe');
  s = s.replace(/\bMaintenez\b/g, 'Maintiens');
  s = s.replace(/\bContrôlez\b/g, 'Contrôle');
  s = s.replace(/\bRespectez\b/g, 'Respecte');
  s = s.replace(/\bAssurez[- ]vous\b/g, 'Assure-toi');
  s = s.replace(/\bSachez\b/g, 'Sache');

  // Questions "estimez-vous", "pensez-vous", "avez-vous", "êtes-vous", "vous devez", etc. (2ᵉ pers. plur. → sing.)
  s = s.replace(/\bestimez[- ]vous\b/gi, 'estimes-tu');
  s = s.replace(/\bpensez[- ]vous\b/gi, 'penses-tu');
  s = s.replace(/\bavez[- ]vous\b/gi, 'as-tu');
  s = s.replace(/\bêtes[- ]vous\b/gi, 'es-tu');
  s = s.replace(/\bfaites[- ]vous\b/gi, 'fais-tu');
  s = s.replace(/\bsavez[- ]vous\b/gi, 'sais-tu');
  s = s.replace(/\bvous\s+devez\b/gi, 'tu dois');
  s = s.replace(/\bvous\s+pouvez\b/gi, 'tu peux');
  s = s.replace(/\bvous\s+avez\b/gi, 'tu as');
  s = s.replace(/\bvous\s+êtes\b/gi, 'tu es');
  s = s.replace(/\bvous\s+savez\b/gi, 'tu sais');
  s = s.replace(/\bvous\s+faites\b/gi, 'tu fais');
  s = s.replace(/\bvous\s+voyez\b/gi, 'tu vois');
  s = s.replace(/\bvous\s+prenez\b/gi, 'tu prends');

  // "votre" (adressé à l'enseignant) → "ton" (masculin) ou "ta" (féminin)
  s = s.replace(/\bvotre\s+(véhicule|regard|siège|permis|apprentissage|niveau|volant|rétroviseur|pneu|frein|feu|point|comportement|entourage|choix)\b/gi, 'ton $1');
  s = s.replace(/\bvotre\s+(conduite|attention|posture|vitesse|trajectoire|voiture|séance|leçon|main|ceinture|circulation|priorité|distance|marche|manœuvre|sécurité)\b/gi, 'ta $1');
  // "vos" (pluriel invariant) → "tes"
  s = s.replace(/\bvos\s+(passagers|réglages|contrôles|rétros|rétroviseurs|freins|pneus|feux|pédales|commandes|habitudes|choix|comportements|regards)\b/gi, 'tes $1');

  // Nettoyage
  s = s.replace(/[ \t]{2,}/g, ' ');
  s = s.replace(/[ \t]+$/gm, '');
  s = s.charAt(0).toUpperCase() + s.slice(1);
  return s;
}

// Applique toTu à un item éventuellement objet (utilisé pour risques_listes = [{titre, text}])
export function toTuFlat(v) {
  if (v == null) return '';
  const str = typeof v === 'string' ? v : (v?.titre || v?.text || '');
  return toTu(str);
}

// Variante GROUPE (RVP, formation AM, cours en salle) : convertit le même
// contenu REMC vers du vousvoiement pluriel — s'adresse à un GROUPE
// (élève + accompagnateur, ou plusieurs élèves + parents).
export function toVous(input) {
  if (!input) return '';
  let s = String(input);

  // Reformulations d'incipit REMC → vous (pluriel groupe)
  s = s.replace(/^Aidez\s+votre\s+élève\s+à\s+(comprendre|savoir|apprendre|percevoir|identifier|maîtriser|analyser)\b/i, 'Vous allez $1');
  s = s.replace(/Aidez\s+votre\s+élève\s+à\s+/gi, 'Vous allez ');
  s = s.replace(/Amenez\s+votre\s+élève\s+à\s+/gi, 'Vous allez ');
  s = s.replace(/Faites\s+découvrir\s+à\s+votre\s+élève\s+/gi, 'Vous allez découvrir ');
  s = s.replace(/Expliquez\s+à\s+votre\s+élève\s+/gi, 'Nous allons voir ensemble ');
  s = s.replace(/Puisez\s+dans\s+les\s+ressources\s+de\s+votre\s+élève\.?\s*/gi, '');
  s = s.replace(/Partez\s+d[’']une\s+situation\s+vécue\s*,?\s*pour\s+faire\s+ressortir\s+/gi, "Partons d'une situation vécue pour faire ressortir ");
  s = s.replace(/Démontrez\s+qu['’]?\s*/gi, "Retenez qu'");
  s = s.replace(/Présentez\s+/gi, 'Nous allons voir ');

  // Boilerplate auto-généré
  s = s.replace(/Pour\s+lui\s+apprendre\s+à\s+/gi, 'Pour vous apprendre à ');
  s = s.replace(/Pour\s+lui\s+(permettre|montrer|expliquer|faire|donner|éviter)\b/gi, 'Pour vous $1');
  s = s.replace(/proposer\s+à\s+l['’]?élève\s+de\s+/gi, 'vous proposer de ');
  s = s.replace(/Le\s+but\s+étant\s+qu['’]?il\s+/gi, 'Le but étant que vous ');
  s = s.replace(/Le\s+but\s+étant\s+qu['’]?elle\s+/gi, 'Le but étant que vous ');
  s = s.replace(/Il\s+est\s+important\s+que\s+l['’]?élève\s+puisse\s+/gi, 'Il est important que vous puissiez ');
  s = s.replace(/Il\s+est\s+important\s+que\s+l['’]?élève\s+/gi, 'Il est important que vous ');
  s = s.replace(/Ces\s+arguments\s+doivent\s+l['’]amener\s+à\s+/gi, 'Ces arguments doivent vous amener à ');
  s = s.replace(/(doivent|doit|peut|peuvent)\s+l['’](amener|aider|inciter|encourager|permettre|conduire|pousser)\s+à\s+/gi,
    (m, verb, verb2) => `${verb} vous ${verb2} à `);

  // « à l'élève » etc.
  s = s.replace(/\bà\s+l['’]?élève\b/gi, 'à vous');
  s = s.replace(/\bde\s+l['’]?élève\b/gi, 'de vous');
  s = s.replace(/\bpour\s+l['’]?élève\b/gi, 'pour vous');
  s = s.replace(/\bchez\s+l['’]?élève\b/gi, 'chez vous');
  s = s.replace(/\bavec\s+l['’]?élève\b/gi, 'avec vous');

  // « l'élève + verbe »
  s = s.replace(/\bl['’]?élève\s+doit\s+/gi, 'vous devez ');
  s = s.replace(/\bl['’]?élève\s+peut\s+/gi, 'vous pouvez ');
  s = s.replace(/\bl['’]?élève\s+sait\s+/gi, 'vous savez ');
  s = s.replace(/\bl['’]?élève\s+prend\s+/gi, 'vous prenez ');
  s = s.replace(/\bl['’]?élève\s+puisse\s+/gi, 'vous puissiez ');
  s = s.replace(/\bl['’]?élève\s+prenne\s+/gi, 'vous preniez ');
  s = s.replace(/\bl['’]?élève\s+fait\s+/gi, 'vous faites ');
  s = s.replace(/\bl['’]?élève\s+va\s+/gi, 'vous allez ');
  s = s.replace(/\bl['’]?élève\s+est\s+/gi, 'vous êtes ');
  s = s.replace(/\bl['’]?élève\s+a\s+/gi, 'vous avez ');

  // « qu'il/qu'elle + verbe » → « que vous + verbe »
  s = s.replace(/\bqu['’]il\s+prenne\s+conscience\b/gi, 'que vous preniez conscience');
  s = s.replace(/\bqu['’]il\s+puisse\b/gi, 'que vous puissiez');
  s = s.replace(/\bqu['’]il\s+comprenne\b/gi, 'que vous compreniez');
  s = s.replace(/\bqu['’]il\s+identifie\b/gi, 'que vous identifiez');
  s = s.replace(/\bqu['’]il\s+maîtrise\b/gi, 'que vous maîtrisiez');
  s = s.replace(/\bqu['’]il\s+apprenne\b/gi, 'que vous appreniez');
  s = s.replace(/\bqu['’]il\s+réagisse\b/gi, 'que vous réagissiez');
  s = s.replace(/\bqu['’]il\s+sache\b/gi, 'que vous sachiez');

  // Puces infinitives « De vérifier » → « Vous allez vérifier »
  s = s.replace(/^De\s+([a-zàâçéèêëîïôûùüÿœ])/i, (m, c) => 'Vous allez ' + c.toLowerCase());
  s = s.replace(/(\n\s*[-•]\s*)De\s+([a-zàâçéèêëîïôûùüÿœ])/gi, (m, dash, c) => `${dash}vous allez ${c.toLowerCase()}`);
  s = s.replace(/^D['’]([aeiouhy])/i, (m, v) => `Vous allez ${v.toLowerCase()}`);
  s = s.replace(/(\n\s*[-•]\s*)D['’]([aeiouhy])/gi, (m, dash, v) => `${dash}vous allez ${v.toLowerCase()}`);

  // Verbes pronominaux « s'installer » → « vous installer »
  s = s.replace(/\bs['’]y\s+([a-zàâçéèêëîïôûùüÿœ])/gi, (m, c) => `vous y ${c.toLowerCase()}`);
  s = s.replace(/\bs['’](installer|arrêter|engager|assurer|approcher|éloigner|adapter|habituer|préparer|placer|positionner|orienter|informer)\b/gi,
    (m, verb) => `vous ${verb.toLowerCase()}`);
  s = s.replace(/^S['’](installer|arrêter|engager|assurer|approcher|éloigner|adapter|habituer|préparer|placer|positionner|orienter|informer)\b/i,
    (m, verb) => `Vous ${verb.toLowerCase()}`);
  s = s.replace(/(\n\s*[-•]\s*)S['’](installer|arrêter|engager|assurer|approcher|éloigner|adapter|habituer|préparer|placer|positionner|orienter|informer)\b/gi,
    (m, dash, verb) => `${dash}vous ${verb.toLowerCase()}`);

  // Références "l'élève" → "vous", "votre élève" → "vous", "les élèves" → "vous"
  s = s.replace(/\bvotre\s+élève\b/gi, 'vous');
  s = s.replace(/\bl['’]?élève\b/gi, 'vous');
  s = s.replace(/\bles\s+élèves\b/gi, 'vous');

  // Nettoyage (les impératifs pluriels et le vouvoiement restent en pluriel)
  s = s.replace(/[ \t]{2,}/g, ' ');
  s = s.replace(/[ \t]+$/gm, '');
  s = s.charAt(0).toUpperCase() + s.slice(1);
  return s;
}

export function toVousFlat(v) {
  if (v == null) return '';
  const str = typeof v === 'string' ? v : (v?.titre || v?.text || '');
  return toVous(str);
}
